// poly fill for Node.remove
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function(arr) {
	arr.forEach(function(item) {
		if (item.hasOwnProperty("remove")) {
			return;
		}
		Object.defineProperty(item, "remove", {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				if (this.parentNode !== null) {
					this.parentNode.removeChild(this);
				}
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


var ATDSuperTable = function(el, options) {
	if (!NodeList.prototype.forEach) {
		NodeList.prototype.forEach = Array.prototype.forEach;
	}

	var containerEl = el;
	var dataTable = containerEl.querySelectorAll("table")[0];
	var lockTable = null;
	var lockTableRear = null;
	var autoLocked = getAutoLocked("data-auto-lock");
	var autoLockedRear = [];
	var manuallyLocked = [];
	var allLocked = [];
	var originalHeaders = {};
	var settings = Object.assign(
		{
			stackedBreakpoint: 767,
			maxLocked: true,
			onRenderLayoutComplete: () => {},
			manuallyLockedColumns: []
		},
		options
	);

	manuallyLocked = settings.manuallyLockedColumns;

	dataTable.querySelectorAll("th").forEach(function(node) {
		const columnName = trimText(node.innerText);
		originalHeaders[columnName] = Object.keys(originalHeaders).length;
	});

	layoutTable();

	window.addEventListener("resize", layoutTable);

	function layoutTable() {
		clearLockTables();
		containerEl.classList.remove("compact", "stacked");


		if (window.innerWidth <= settings.stackedBreakpoint) {
			containerEl.classList.add("stacked");
			setStackedHeadings();
			return;
		}
		containerEl.classList.add("compact");

		allLocked = autoLocked.concat(manuallyLocked);
		allLocked.sort((a,b) => {
			//if compare returns value < 0, than a < b, >0 a>b, equal values otherwise
			return a.index - b.index;
		});

		if (dataTable.offsetWidth > containerEl.firstChild.offsetWidth || allLocked.length > 0) {
			placeLocks();
		}

		if (allLocked.length > 0) {
			lockTable = createLockTable();
			calculateLockTableSize(lockTable, allLocked);
			makeColumnsVisible(allLocked, lockTable);
		}

		autoLockedRear = getAutoLocked("data-auto-lock-rear");
		if (autoLockedRear.length) {
			lockTableRear = createLockTable(true);
			calculateLockTableSize(lockTableRear, autoLockedRear);
			makeColumnsVisible(autoLockedRear, lockTableRear);
		}

		calculateMaxLocked();

		var lockButtons = containerEl.querySelectorAll("[data-lock-column]");
		lockButtons.forEach(function(btn) {
			btn.addEventListener("click", toggleLocked);
		});

		$(containerEl.firstElementChild).floatingScroll("destroy").floatingScroll("init");

		settings.onRenderLayoutComplete(manuallyLocked);
	}

	function setStackedHeadings() {
		var columnHeads = dataTable.querySelectorAll("th");
		var rows = dataTable.querySelectorAll("tbody tr");
		rows.forEach(function(row) {
			var cells = row.querySelectorAll("td");
			cells.forEach(function(cell, i) {
				if (
					columnHeads[i].innerText.length &&
					!columnHeads[i].innerText.match(/^\s$/) &&
					!columnHeads[i].innerText.match(/\xA0$/g)
				) {
					cell.setAttribute("data-heading", columnHeads[i].innerText);
				}
			});
		});
	}

	function removeFromLocked(lockedList, text) {
		return lockedList.filter((value) => {
			return text  !== value.text;
		});
	}

	function toggleLocked(e) {
		var columnHead = e.target.parentElement;
		var headerRow = columnHead.parentElement;
		var isLocked = lockTable ? lockTable.table.contains(columnHead) : false;
		const columnText = columnHead.innerText;

		clearLockTables();

		if (isLocked) {
			manuallyLocked = removeFromLocked(manuallyLocked, columnText);
			autoLocked = removeFromLocked(autoLocked, columnText);
		} else {
			manuallyLocked.push({
				index: Array.prototype.indexOf.call(headerRow.children, columnHead),
				text: columnText
			});
		}

		layoutTable();
	}

	function getAutoLocked(autoLockAttr) {
		var lockedList = [];
		var columnHeads = dataTable.querySelectorAll("th");
		for (var i = 0, length = columnHeads.length; i < length; i++) {
			if (columnHeads[i].hasAttribute(autoLockAttr)) {
				lockedList.push({
					index: i,
					el: columnHeads[i]
				});
			}
		}

		return lockedList;
	}

	function placeLocks() {
		var columnHeads = dataTable.querySelectorAll("th");
		columnHeads.forEach(function(th) {
			placeLock(th);
		});
	}

	function placeLock(th) {
		var lock = document.createElement("A");
		lock.setAttribute("data-lock-column", "");
		th.appendChild(lock);
	}

	function clearLockTables() {
		restoreOriginalOrder();

		dataTable.querySelectorAll("th").forEach(function(node) {
			var anchor = node.querySelector("[data-lock-column]");
			if (anchor) {
				anchor.remove();
			}
		});

		if (lockTable) {
			containerEl.removeChild(lockTable.container);
			lockTable = null;
		}

		if (lockTableRear) {
			containerEl.removeChild(lockTableRear.container);
			lockTableRear = null;
		}
	}

	function restoreOriginalOrder() {
		Object.keys(originalHeaders).forEach(key => {
			const currentOrder = dataTable.querySelectorAll("th");
			let indexes = {};

			currentOrder.forEach(function(node) {
				const columnName = trimText(node.innerText);
				indexes[columnName] = Object.keys(indexes).length;
			});

			if (originalHeaders[key] !== indexes[key]) {
				moveColumn(dataTable, indexes[key], originalHeaders[key]);
			}
		});
	}

	function moveColumn(table, index, position, isRear) {
		if (isRear) {
			return;
		}
		var tableRows = table.querySelectorAll("tbody tr");
		var tableHeadRow = table.querySelector("thead tr");
		var tableFootRows = table.querySelectorAll("tfoot tr");

		tableHeadRow.insertBefore(
			tableHeadRow.children[index],
			tableHeadRow.childNodes[position]
		);

		for (var i = 0, length = tableRows.length; i < length; i++) {
			tableRows[i].insertBefore(
				tableRows[i].children[index],
				tableRows[i].childNodes[position]
			);
		}

		for (var i = 0, length = tableFootRows.length; i < length; i++) {
			tableFootRows[i].insertBefore(
				tableFootRows[i].children[index],
				tableFootRows[i].childNodes[position]
			);
		}
	}

	function calculateLockTableSize(lockTable, lockedList) {
		var width = 0;
		var columnHeads = lockTable.table.querySelectorAll("th");
		var unlockedTableHeaders = dataTable.querySelectorAll("th");
		var rows = lockTable.table.querySelectorAll("tbody tr");
		var footerRows = lockTable.table.querySelectorAll("tfoot tr");

		for (var i = 0, length = lockedList.length; i < length; i++) {
			width += unlockedTableHeaders[lockedList[i].index].offsetWidth;
			columnHeads[lockedList[i].index].style.visibility = "visible";
			columnHeads[lockedList[i].index].style.pointerEvents = "auto";
			columnHeads[lockedList[i].index].style.width = `${unlockedTableHeaders[lockedList[i].index].offsetWidth}px`;
			columnHeads[lockedList[i].index].style.minWidth = `${unlockedTableHeaders[lockedList[i].index].offsetWidth}px`;

			for (
				var rows_i = 0;
				rows_i < rows.length;
				rows_i++
			) {
				rows[rows_i].children[lockedList[i].index].style.visibility = "visible";
				rows[rows_i].children[lockedList[i].index].style.pointerEvents = "auto";
			}

			for (var footerRows_i = 0; footerRows_i < footerRows.length; footerRows_i++) {
				footerRows[footerRows_i].children[lockedList[i].index].style.visibility = "visible";
				footerRows[footerRows_i].children[lockedList[i].index].style.pointerEvents = "auto";
			}

			moveColumn(lockTable.table, lockedList[i].index, i, lockTable.isRear);
			moveColumn(dataTable, lockedList[i].index, i, lockTable.isRear);
		}
		lockTable.container.style.width = width + "px";
	}

	function calculateMaxLocked() {
		if (settings.maxLocked === false || lockTable == undefined) {
			return;
		}

		var containerWidth = containerEl.offsetWidth;
		var lockContainerWidth = lockTable.container.offsetWidth;

		if (lockContainerWidth > containerWidth / 2) {
			dataTable.classList.add("max-locked");
		} else {
			dataTable.classList.remove("max-locked");
		}
	}

	function makeColumnsVisible(lockedList, lockTable) {
		if (lockTable) {
			const columns = Array.prototype.slice.call(lockTable.table.querySelectorAll("th"), 0, lockedList.length);
			columns.forEach(column => {
				column.style.visibility = "visible";
			});
		}
	}

	function createLockTable(isRear) {
		//create lock table
		var lockTable = {
			table: dataTable.cloneNode(true),
			container: document.createElement("div"),
			isRear: isRear
		};

		lockTable.table.classList.add("lock-table");
		lockTable.table.classList.remove("max-locked");
		if (isRear) {
			lockTable.container.classList.add("rear");
			lockTable.table.setAttribute("id", "lock-table-rear");
		} else {
			lockTable.table.setAttribute("id", "lock-table");
		}
		lockTable.container.classList.add("lock-table-container");

		var inner = document.createElement("div");
		inner.classList.add("lock-table-inner");

		inner.appendChild(lockTable.table);
		lockTable.container.appendChild(inner);
		lockTable.container.setAttribute("aria-hidden", "");
		containerEl.appendChild(lockTable.container);

		return lockTable;
	}

	function trimText(text) {
		return text
			.replace(/(\n|\t)/g, "")
			.trim();
	}

	return {
		layoutTable: layoutTable,
		clearLockTables: clearLockTables
	};
};

export default ATDSuperTable;
